import { useTranslation } from "react-i18next";
import { ArrowRight, Sprout } from "lucide-react";
import { useCockpitState } from "./cockpitState";

export const SeasonStrip = ({ onOpenCompass }: { onOpenCompass: () => void }) => {
  const { t } = useTranslation();
  const { season, weekFocus } = useCockpitState();
  if (!season?.line) return null;
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 rounded-xl border border-border/50 bg-card/70 px-4 py-2 text-[12.5px] text-muted-foreground">
      <span className="inline-flex items-center gap-1.5">
        <Sprout className="w-3.5 h-3.5 text-primary/70" />
        {t("season_strip_season")} <span className="text-foreground/85 font-medium">{season.line}</span>
      </span>
      {weekFocus?.line && (
        <span>
          {t("season_strip_focus")} <span className="text-foreground/85 font-medium">{weekFocus.line}</span>
        </span>
      )}
      <button
        onClick={onOpenCompass}
        className="ms-auto inline-flex items-center gap-1 text-primary/80 hover:text-primary min-h-[44px] px-1"
      >
        {t("cockpit_mode_compass")}
        <ArrowRight className="w-3 h-3 rtl:rotate-180" />
      </button>
    </div>
  );
};
